import {Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export class PortalRename implements Parameter {
	public fileName?: string;

	constructor(data: any) {
		this.fileName = FunctionHelper.exists(data.fileName) ? data.fileName : "";
	}

	public static getFileNameDefault(): string {
		return "";
	}

	public static fromJson(data: any): PortalRename {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalRename(data);
	}

	public toJson(): any {
		return {
			'fileName': this.fileName
		};
	}

	public clone(): PortalRename {
		return PortalRename.fromJson(this.toJson());
	}
}